import { render, staticRenderFns } from "./ShareWithButtons.vue?vue&type=template&id=4f2f66d9&"
import script from "./ShareWithButtons.vue?vue&type=script&lang=js&"
export * from "./ShareWithButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports